const popular = [
  {
    title: "All",
    path: "/",
  },
  {
    title: "Rice",
    path: "/",
  },
  {
    title: "Fried",
    path: "/",
  },
  {
    title: "Soup",
    path: "/",
  },
  {
    title: "Group Hot",
    path: "/",
  },
  {
    title: "Group Iced",
    path: "/",
  },
  {
    title: "Milk",
    path: "/",
  },
  {
    title: "Smoothie",
    path: "/",
  },
  {
    title: "Italian Soda",
    path: "/",
  },
];
export { popular };
